import { Component, input, Optional, Self } from '@angular/core';
import { ControlBase } from '../base/control.base';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { NgControl } from '@angular/forms';
import { InputType } from './types/input.type';

@Component({
  selector: 'cec-input',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatLabel, TranslateModule],
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss', '../shared/input.styles.scss']
})
export class InputComponent extends ControlBase<string | number> {

  /** Input type reference */
  public type = input<InputType>('text');

  /** Min input value reference */
  public min = input<number | null>(null);

  /** Max input value reference */
  public max = input<number | null>(null);

  constructor(@Optional() @Self() public ngControl: NgControl) {
    super(ngControl);
  }
  
  /** @inheritdoc */
  protected getControlValue(): string | number {
    return this.value;
  }

  /** @inheritdoc */
  protected setControlValue(val: string | number): void {
    /** if value is not set, sets the null value */
    if (!val) {
      return null;
    }

    /** do not allow user to set higher value as max if the max value is set and input is type of number */
    if (this.type() === 'number' && this.max() && Number(val) > this.max()) {
      val = this.max();
    }

    /** do not allow user to set lower value as min if the min value is set and input is type of number */
    if (this.type() === 'number' && this.min() !== null && Number(val) < this.min()) {
      val = this.min();
    }

    /** sets the input value */
    this.value = val;
  }

  /** @inheritdoc */
  protected setControlDisabled(isDisable: boolean): void {
    this.isDisabled.set(isDisable);
  }

  /**
   * Sets value of the control
   * @param event the input event
   */
  protected onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.ngControl?.control?.setValue(inputElement.value);
  }
}
